exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".image-comp-img {\n  margin: 0px;\n  padding: 0px;\n}\n", ""]);

// exports
